import { isEmpty } from 'radash';

interface OptionType {
    label?: string;
    value: string;
}

/**
 * Maps a Physical Combobox selection to the form value. Empty clears to
 * ''; otherwise the unit string is stored in dot notation.
 */
function normalizePhysicalComboboxValue(newValue: OptionType | null | undefined): string {
    if (newValue == null || isEmpty(newValue)) {
        return '';
    }
    const value = newValue.value;
    return value ? value.replace(',', '.') : value;
}

export { normalizePhysicalComboboxValue };
